import React from 'react';

const ProductSummaryPlan = ({item, plan}) => (
  <div className="row row-all-15 align-items-stretch">
    <div className="col-lg-3">
      <div className="block-relative mb-3">
        <img width="100%" className="rounded border-1 block-reservation__img"
             src="/tour/images/830__fitzroy-island2-min.jpg" alt=""/>
        <img className="block-reservation__label"
             src="/themes/Bootstrap4-alpha6/dev/images/icon/sale.svg" alt=""/>
      </div>
    </div>
    <div className="col-lg-9">
      <div className="row row-all-15 align-items-stretch h-100">
        <div className="col-lg-8">
          <h3 className="block-reservation__title">{plan.name}</h3>
          <div className="block-reservation__desc" dangerouslySetInnerHTML={{__html: plan.desc}}/>
          <div className="block-reservation__icon">
            <div className="mb-1">
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="d-lg-flex flex-column h-100">
            <div className="mb-auto">
              <div className="block-reservation__price">豪ドル
                <span className="card__before">${plan.original}</span>
                <span className="font-weight-bold text-success doll">${plan.adult}~</span>
              </div>
            </div>
            <div>
              <a href={`/travel/order/?id=${item.id}&pid=${plan.id}`} className="btn btn-success btn-block">このプランで予約する</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProductSummaryPlan;



// WEBPACK FOOTER //
// ./src/pages/travel/components/ProductSummaryPlanItem.js